module.exports = __webpack_public_path__ + "static/media/CONSTRUCTION 1.111d35b2.jpg";